import { Mol } from '@retro-ui/api-contract';
import { getSmallestCycles, namedMols } from '@moleculeone/draw';

export interface CommonMol extends Mol {
  ringsCount: number;
  elements: Set<string>;
}

export const getCommonMols = (): CommonMol[] => {
  const commonMols = (Object.values(namedMols.exampleMols) as Mol[])
    .filter(mol => mol.key !== 'empty')
    .map(mol => {
      const { distinctCycles } = getSmallestCycles(mol);
      const ringsCount = distinctCycles.length;

      const elements = new Set<string>();
      for (const atom of Object.values(mol.atoms)) {
        elements.add(atom.element);
      }

      return {
        ...mol,
        ringsCount,
        elements,
      };
    });

  return commonMols;
};
